import { create } from 'zustand';
import { devtools, persist, subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { KharonStore } from './types';
import { createAuthSlice } from './slices/authSlice';
import { createDataSlice } from './slices/dataSlice';
import { createUISlice } from './slices/uiSlice';

export const useStore = create<KharonStore>()(
  subscribeWithSelector(
    devtools(
      immer((...a) => ({
        ...createAuthSlice(...a),
        ...createDataSlice(...a),
        ...createUISlice(...a),
      })),
      { name: 'KharonStore' }
    )
  )
);
